import React from 'react';
import Comparator from './pages/Comparator';

const App = ({ contact, locale, quotation, testDrive }) => {
    return (
        <Comparator contact={contact} locale={locale} quotation={quotation} testDrive={testDrive} />
    );
}

export default App;